const NotFound = () => {
  return (
    <div className="w-full text-center flex justify-center items-center h-[500px]">
      <p className="text-2xl text-palePink">
        Oops something went wrong. Please try again later.
      </p>
    </div>
  );
};

export default NotFound;
